module.exports = __webpack_public_path__ + "static/media/PainScale.d211d3f5.svg";